import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Level1 from "./Level1";
import Level2 from "./Level2";
import { AnimatePresence, motion } from "framer-motion";
import Level3 from "./Level3";
import Level4 from "./Level4";
import Level5 from "./Level5";
import Level6 from "./Level6";
import Level7 from "./Level7";
import { setCurrentStep, setQuestions } from "../../store/QuestionnaireSlice";
import { useNavigate } from "react-router-dom";
import { useInterceptor } from "providers/InterceptorProvider";

const Questionnaire = () => {
  const { api } = useInterceptor();
  const dispatch = useDispatch();
  const currentStep = useSelector((state) => state.questionnaire.currentStep);
  const questions = useSelector((state) => state.questionnaire.questions);
  const [organizationChecked, setOrganizationChecked] = useState(false);
  const navigate = useNavigate();
  const [hasOrganizationData, setHasOrganizationData] = useState(false);

  const fetchQuestions = async () => {
    try {
      const response = await api.get(`/questions/getAllquestions`);
      const result = await response.data;
      if (result.success) {
        dispatch(setQuestions(result.data.sort((a, b) => a.level - b.level)));
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  useEffect(() => {
    if (organizationChecked && !hasOrganizationData) {
      fetchQuestions();
    }
  }, [organizationChecked, hasOrganizationData]);
  useEffect(() => {
    if (hasOrganizationData) {
      navigate("/organization-tree");
    }
  }, [hasOrganizationData, navigate]);
  useEffect(() => {
    fetchQuestions();
  }, []);
  const handleNext = () => {
    dispatch(setCurrentStep(currentStep + 1));
  };

  const handleBack = () => {
    dispatch(setCurrentStep(currentStep - 1));
  };

  const renderLevel = () => {
    switch (currentStep) {
      case 1:
        return <Level1 onNext={handleNext} />;
      case 2:
        return (
          <Level2 onNext={handleNext} onBack={handleBack} placement="default" />
        );
      case 3:
        return <Level3 onNext={handleNext} onBack={handleBack} />;
      case 4:
        return <Level4 onNext={handleNext} onBack={handleBack} />;
      case 5:
        return <Level5 onNext={handleNext} onBack={handleBack} />;
      case 6:
        return <Level6 onNext={handleNext} onBack={handleBack} />;
      case 7:
        return <Level7 onNext={handleNext} onBack={handleBack} />;
      default:
        return <Level1 onNext={handleNext} onBack={handleBack} />;
    }
  };

  return (
    <div className="mt-[54px] font-inter max-w-[1200px] max-xl:px-5 mx-auto w-full mb-60">
      <div className="flex justify-between">
        <h1 className="text-[32px] tracking-wide mb-[29px] font-medium">
          Asset Allocation
        </h1>

        {/* progress circle */}
        <div className="rounded-full relative p-2 w-14 h-14 max-md:hidden">
          <div className="w-full h-full rounded-full bg-gray-100"></div>

          <div
            className="absolute top-0 left-0 w-full h-full"
            style={{
              background: `conic-gradient(rgb(20 83 45) ${
                currentStep * 14.285714285714286
              }%, rgba(235, 230, 230, 1) ${currentStep * 14.285714285714286}%)`,
              borderRadius: "100%",
            }}
          ></div>

          <div
            className="absolute top-0 left-0 w-full h-full rounded-full bg-white flex items-center justify-center m-[4px]"
            style={{ width: "calc(100% - 8px)", height: "calc(100% - 8px)" }}
          >
            <span className="text-[16px] font-medium">{currentStep}/7</span>
          </div>
        </div>
      </div>

      {/* <div className="bg-[#F4F5F6] pt-8 pb-6 px-10 rounded-lg"> */}
      <AnimatePresence mode="popLayout">
        <motion.div
          key={currentStep}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.1 }}
        >
          {renderLevel()}
        </motion.div>
      </AnimatePresence>
      {/* </div> */}
    </div>
  );
};

export default Questionnaire;
